import { z } from "zod";

import { createQueryRequestDefinition } from "~/lib/network/definitions/create";

import { listTestReportsResponseSchema, testReportResponseSchema } from "./schemas";

export const listTestReportsQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "test-runs", "list"],
  host: "cap-srv",
  method: "GET",
  path: "/proxy/oasis/camel/test-reports",
  paramsSchema: z.object({
    commitHash: z.string().optional(),
    tag: z.string().optional(),
  }),
  responseSchema: listTestReportsResponseSchema,
});

export const getTestReportQuery = createQueryRequestDefinition({
  queryKey: ["oasis", "test-runs", "detail"],
  host: "cap-srv",
  method: "GET",
  path: "/proxy/oasis/camel/test-reports/:reportId",
  responseSchema: testReportResponseSchema,
});
